import React from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { Grid, Header, Divider, Segment, Button, Form, Message } from 'semantic-ui-react';

class ForgotPassword extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      email: '',
      loading: false,
      reqResponse: null,
      submitDisabled: false,
    };

    this.onInputChange = this.onInputChange.bind(this);
    this.onSubmit = this.onSubmit.bind(this);
  }

  onInputChange(evt) {
    this.setState({ email: evt.target.value, reqResponse: null });
  }

  onSubmit(e) {
    e.preventDefault();
    const { email } = this.state;

    this.setState({ loading: true, submitDisabled: true });

    // /dealer/api/generate-forgot-password-code/
    axios.post('/generate-forgot-password-code/', { email })
      .then(res => {

        this.setState({
          loading: false,
          submitDisabled: false,
          reqResponse: {
            header: 'Email Sent',
            content: `We've emailed a password reset link to ${email}.`,
            success: true,
          },
          email: '',
        });
      })
      .catch(err => {
        this.setState({
          reqResponse: {
            header: 'There was a problem',
            content: err.response.data.ui_message,
            success: false,
          },
          loading: false,
        });

        setTimeout(() => {
          this.setState({
            reqResponse: null,
            submitDisabled: false,
          });
        }, 5000);
      });
  }

  render() {
    const { email, loading, reqResponse, submitDisabled } = this.state;

    const buttonDisabled = submitDisabled || !email ? true : false;

    return (
      <Grid className="auth-grid" verticalAlign="middle" centered container columns={1}>
        <Grid.Column width={window.innerWidth <= 1024 ? 10 : 7}>
          <Segment padded color="blue">
            <Header
              textAlign="center"
              subheader="Enter your email address and we will send you a password reset link"
              content="Forgot Password"
              size="large"
            />
            {
              reqResponse
                ? (
                    <Message
                      header={reqResponse.header}
                      icon={reqResponse.success ? 'check' : 'exclamation'}
                      positive={reqResponse.success ? true : false}
                      error={!reqResponse.success ? true : false}
                      content={reqResponse.content}
                    />
                  )
                : null
            }
            <Form onSubmit={this.onSubmit} loading={loading}>
              <Form.Input
                label="Email"
                name="email"
                required
                value={email}
                onChange={this.onInputChange}
                placeholder="Email"
              />
              <Button primary fluid disabled={buttonDisabled} content="Submit" />
            </Form>
            <Divider hidden />
            <Link to="/dealer/">Remember password?</Link>
          </Segment>
        </Grid.Column>
      </Grid>
    );
  }
}

export default ForgotPassword;
